import CFG from '../gameLoopConfig.json';
import {
  ENEMY_SIZE, ENEMY_SPEED, ENEMY_DAMAGE,
  TIER_BOSS_SIZE, TIER_BOSS_SWING_RANGE, TIER_BOSS_SWING_CD,
  ROCK_COLLISION_SCALE,
} from '../../../constants';
import { resolveRectOverlap } from '../helpers';

const RC = CFG.rangedEnemy;
const TB = CFG.tierBoss;

export function updateEnemyMovement(s, dt, timestamp, pcx, pcy, setGameState) {
  const isFrozen   = timestamp < (s.frozenUntil   ?? 0);
  const isSlowTime = timestamp < (s.slowTimeUntil ?? 0);
  if (isFrozen) return false;

  const enmSpd = ENEMY_SPEED * s.enemySlowMult
    * (isSlowTime ? (s.slowTimeFactor ?? 0.3) : 1)
    * (s.activeModifier?.enemySpeedMult ?? 1);

  for (const enemy of s.enemies) {
    const eSize = enemy.size ?? ENEMY_SIZE;
    const spd2  = enemy.isTierBoss ? enmSpd * TB.speedFactor
                : enemy.isBoss    ? enmSpd * 0.7
                : enmSpd;
    const dx   = pcx - (enemy.x + eSize / 2);
    const dy   = pcy - (enemy.y + eSize / 2);
    const dist = Math.sqrt(dx * dx + dy * dy);

    if (enemy.isTierBoss) {
      if (dist > 0) { enemy.x += (dx / dist) * spd2; enemy.y += (dy / dist) * spd2; }

      if (timestamp - (enemy.lastSwingTime ?? -TIER_BOSS_SWING_CD) >= TIER_BOSS_SWING_CD) {
        enemy.lastSwingTime = timestamp;
        const isShielded = timestamp < (s.shieldUntil ?? 0);
        if (!isShielded && !s.isDashing && timestamp - s.lastHitTime > (s.hitCooldown ?? 1500)) {
          const swingDmg = Math.max(1, Math.round((enemy.damage ?? 30) - (s.armor ?? 0)));
          s.hp          -= swingDmg;
          s.lastHitTime  = timestamp;
          s.floatingTexts.push({
            id: `ft_tbswing_${timestamp}`, x: pcx, y: pcy - 30,
            text: `💥-${swingDmg}`, color: '#ff2200',
            startTime: timestamp, duration: 1200,
          });
          // Fire sword-sweep animation effect centred on the tier boss
          s.spellEffects.push({
            id: `se_tbatk_${timestamp}`, type: 'tier_boss_attack',
            x: enemy.x + TIER_BOSS_SIZE / 2, y: enemy.y + TIER_BOSS_SIZE / 2,
            radius: TIER_BOSS_SWING_RANGE, startTime: timestamp, duration: 700,
          });
          if (s.hp <= 0) { s.alive = false; setGameState('dead'); return true; }
        }
      }

    } else if (enemy.isRanged) {
      if (dist > 0) {
        if (dist > RC.preferredDist + RC.preferredTolerance) {
          enemy.x += (dx / dist) * spd2; enemy.y += (dy / dist) * spd2;
        } else if (dist < RC.preferredDist - RC.preferredTolerance) {
          enemy.x -= (dx / dist) * spd2; enemy.y -= (dy / dist) * spd2;
        }
      }
      if (timestamp - (enemy.lastShootTime ?? -RC.shootCooldown) >= RC.shootCooldown) {
        enemy.lastShootTime = timestamp;
        if (dist > 0) {
          if (!s.projectiles) s.projectiles = [];
          s.projectiles.push({
            id: `dqp_${s.nextProjId++}`,
            x: enemy.x + eSize / 2 - 5,
            y: enemy.y + eSize / 2 - 5,
            vx: (dx / dist) * RC.projectileSpeed,
            vy: (dy / dist) * RC.projectileSpeed,
            damage:     enemy.damage ?? ENEMY_DAMAGE,
            damageType: enemy.damageType ?? 'physical',
            spawnTime:  timestamp,
          });
        }
      }
    } else if (dist > 0) {
      enemy.x += (dx / dist) * spd2;
      enemy.y += (dy / dist) * spd2;
    }
  }
  return false;
}

export function resolveEnemyRockCollisions(s) {
  if (s.rocks.length === 0) return;
  for (const enemy of s.enemies) {
    const es = enemy.size ?? ENEMY_SIZE;
    for (const rock of s.rocks) {
      // Use the same shrunk collision box as the player so enemies also stop
      // at the visible rock edge rather than the full square bounding box.
      const colSize = rock.size * ROCK_COLLISION_SCALE;
      const offset  = (rock.size - colSize) / 2;
      const colRock = { x: rock.x + offset, y: rock.y + offset };
      if (enemy.x < colRock.x + colSize && enemy.x + es > colRock.x &&
          enemy.y < colRock.y + colSize && enemy.y + es > colRock.y) {
        resolveRectOverlap(enemy, colRock, es, colSize);
        break;
      }
    }
  }
}
